var map = {
	"./about/about.route.js": "993f",
	"./address/address.route.js": "8fb8",
	"./advertisement/advertisement.route.js": "6a3f",
	"./auth/auth.route.js": "23fe",
	"./bill_payment/bill_payment.route.js": "a7b7",
	"./category/category.route.js": "6754",
	"./checkout/checkout.route.js": "ebea",
	"./contact/contact.route.js": "b927",
	"./electronicsMarket/electronicsMarket.route.js": "520f",
	"./fashionMarket/fashionMarket.route.js": "4d9c",
	"./groceryMarket/groceryMarket.route.js": "4be1",
	"./health_care/health_care.route.js": "e7ef",
	"./healthcare_market/healthcare_market.route.js": "0c7a",
	"./home/home.route.js": "1144",
	"./items/items.route.js": "7b79",
	"./location/location.route.js": "3c44",
	"./market/market.route.js": "aeee",
	"./privacy_policy/privacy_policy.route.js": "1917",
	"./product/product.route.js": "d67a",
	"./profile/profile.route.js": "7c61",
	"./return_refund_policy/return_refund_policy.route.js": "81c4",
	"./search/search.route.js": "fa41",
	"./sections/sections.route.js": "35d9",
	"./shopDetails/shopDetails.route.js": "7de0",
	"./terms_conditions/terms_conditions.route.js": "8014",
	"./theme/theme.route.js": "ef32",
	"./wishlist/wishlist.route.js": "bcd9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd35";